import { useLoadScript } from './useLoadScript'

export const useTrustArc = (language?: string) => {
    return useLoadScript(
        '//consent.trustarc.com/notice?domain=goto.com&gtm=1&c=teconsent&js=nj&noticeType=bb&text=true&pcookie',
        true,
        language
    )
}
